import { render, staticRenderFns } from "./search-index.vue?vue&type=template&id=f6a99bdc&"
import script from "./search-index.vue?vue&type=script&lang=js&"
export * from "./search-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports